import { jsxs as c, jsx as s } from "react/jsx-runtime";
import e from "./input-element-top-section.module.less.js";
const m = ({
  label: a,
  legend: l,
  helperText: r,
  errorText: n,
  htmlFor: o = void 0
}) => /* @__PURE__ */ c("div", { className: e.wrapper, children: [
  a && /* @__PURE__ */ s("label", { htmlFor: o, className: e.label, children: /* @__PURE__ */ s("span", { className: "body-s bold mb-0", children: a }) }),
  l && /* @__PURE__ */ s("legend", { className: e.label, children: /* @__PURE__ */ s("span", { className: "body-s bold mb-0", children: l }) }),
  r && /* @__PURE__ */ s("span", { className: [e.helperText, "body-s mb-0"].join(" "), children: r }),
  n && /* @__PURE__ */ c("div", { className: `${e.errorText}`, children: [
    /* @__PURE__ */ s("span", { className: [e.errorIcon, "ui-icon-error"].join(" ") }),
    /* @__PURE__ */ s("span", { children: n })
  ] })
] });
export {
  m as InputElementTopSection,
  m as default
};
